module.exports = __webpack_public_path__ + "static/media/bold_bc.5654a043.png";